export const settingsTextLocales = {
  en: {
    settingsText: {
      security: {
        twoFactorStatus: "2FA Status",
        twoFactorDesc: "Two-factor authentication adds an extra layer of security to your account. For web access, 2FA is managed through your authentication provider. Contact your admin to enable organization-wide 2FA policies.",
        notAvailable: "Not Available",
        currentSession: "Current Session",
        browser: "Browser",
        operatingSystem: "Operating System",
        lastSignInIp: "Last Sign-in IP",
        lastSignIn: "Last Sign-in",
        signedInAs: "Signed In As",
        sessionStatus: "Session Status",
        active: "Active",
        loginHistory: "Login History",
        signInCount: "{{count}} sign-ins",
        loadError: "Login history could not be loaded.",
        empty: "No sign-ins recorded yet.",
        latest: "Latest",
        tipsTitle: "Security Tips",
        tipStrongPassword: "Use a strong, unique password",
        tipEnable2fa: "Enable 2FA when available",
        tipReviewHistory: "Review login history regularly",
        tipSignOutShared: "Sign out from shared devices",
        backToSettings: "Back to Settings"
      },
      profile: {
        newPasswordPlaceholder: "Min 6 characters",
        confirmPasswordPlaceholder: "Repeat new password",
        passwordsMatch: "Passwords match",
        account: "Account",
        provider: "Provider",
        providerEmailPassword: "Email / Password",
        memberSince: "Member Since",
        lastSignIn: "Last Sign In",
        deletePasswordPlaceholder: "Enter your password to confirm"
      },
      workspace: {
        available: "{{count}} workspaces available",
        empty: "No workspaces",
        members: "Members",
        files: "Files",
        storage: "Storage"
      },
      notifications: {
        total: "{{count}} total",
        newBadge: "NEW"
      },
      admin: {
        allLicenses: "All Licenses",
        platformBadge: "PLATFORM",
        demoDataTitle: "Demo Data",
        demoDataDesc: "Creates demo records in Firestore for all modules under the {{email}} account so new companies can explore every page with real Firebase data.",
        seedComplete: "Seed complete: {{count}} writes.",
        seeding: "Seeding...",
        createDemoData: "Create Demo Data",
        seedSignInRequired: "Sign in with a non-guest account to seed demo data.",
        seedConfirm: "This will write demo records into your Firestore database for the currently signed-in user. Continue?",
        auditAction: "Action",
        auditResource: "Resource / Details",
        auditTime: "Time",
        drpackSourceValue: "licenses → AdminLicenses (read-only copy)"
      }
    }
  },
  tr: {
    settingsText: {
      security: {
        twoFactorStatus: "2FA Durumu",
        twoFactorDesc: "İki faktörlü kimlik doğrulama, hesabınıza ek bir güvenlik katmanı ekler. Web erişimi için 2FA, kimlik doğrulama sağlayıcınız üzerinden yönetilir. Kuruluş genelinde 2FA politikalarını etkinleştirmek için yöneticinizle iletişime geçin.",
        notAvailable: "Kullanılamıyor",
        currentSession: "Geçerli Oturum",
        browser: "Tarayıcı",
        operatingSystem: "İşletim Sistemi",
        lastSignInIp: "Son Giriş IP Adresi",
        lastSignIn: "Son Giriş",
        signedInAs: "Giriş Yapan Hesap",
        sessionStatus: "Oturum Durumu",
        active: "Aktif",
        loginHistory: "Giriş Geçmişi",
        signInCount: "{{count}} giriş",
        loadError: "Giriş geçmişi yüklenemedi.",
        empty: "Henüz kayıtlı giriş yok.",
        latest: "En Son",
        tipsTitle: "Güvenlik İpuçları",
        tipStrongPassword: "Güçlü ve benzersiz bir şifre kullanın",
        tipEnable2fa: "Mümkün olduğunda 2FA'yı etkinleştirin",
        tipReviewHistory: "Giriş geçmişinizi düzenli olarak inceleyin",
        tipSignOutShared: "Paylaşılan cihazlarda oturumu kapatın",
        backToSettings: "Ayarlara Dön"
      },
      profile: {
        newPasswordPlaceholder: "En az 6 karakter",
        confirmPasswordPlaceholder: "Yeni şifreyi tekrar girin",
        passwordsMatch: "Şifreler eşleşiyor",
        account: "Hesap",
        provider: "Sağlayıcı",
        providerEmailPassword: "E-posta / Şifre",
        memberSince: "Üyelik Tarihi",
        lastSignIn: "Son Giriş",
        deletePasswordPlaceholder: "Onaylamak için şifrenizi girin"
      },
      workspace: {
        available: "{{count}} çalışma alanı mevcut",
        empty: "Çalışma alanı yok",
        members: "Üyeler",
        files: "Dosyalar",
        storage: "Depolama"
      },
      notifications: {
        total: "Toplam {{count}}",
        newBadge: "YENİ"
      },
      admin: {
        allLicenses: "Tüm Lisanslar",
        platformBadge: "PLATFORM",
        demoDataTitle: "Demo Verileri",
        demoDataDesc: "Yeni şirketlerin her sayfayı gerçek Firebase verileriyle keşfedebilmesi için {{email}} hesabı altında tüm modüllere ait demo kayıtlarını Firestore'da oluşturur.",
        seedComplete: "Demo verileri oluşturuldu: {{count}} yazma işlemi.",
        seeding: "Oluşturuluyor...",
        createDemoData: "Demo Verileri Oluştur",
        seedSignInRequired: "Demo verileri oluşturmak için misafir olmayan bir hesapla giriş yapın.",
        seedConfirm: "Bu işlem, oturum açmış kullanıcı için Firestore veritabanınıza demo kayıtları yazacak. Devam edilsin mi?",
        auditAction: "İşlem",
        auditResource: "Kaynak / Ayrıntılar",
        auditTime: "Zaman",
        drpackSourceValue: "licenses → AdminLicenses (salt okunur kopya)"
      }
    }
  },
  ar: {
    settingsText: {
      security: {
        twoFactorStatus: "حالة المصادقة الثنائية",
        twoFactorDesc: "تضيف المصادقة الثنائية طبقة أمان إضافية إلى حسابك. بالنسبة للوصول عبر الويب، تتم إدارة المصادقة الثنائية من خلال مزوّد المصادقة الخاص بك. تواصل مع المسؤول لتفعيل سياسات المصادقة الثنائية على مستوى المؤسسة.",
        notAvailable: "غير متاح",
        currentSession: "الجلسة الحالية",
        browser: "المتصفح",
        operatingSystem: "نظام التشغيل",
        lastSignInIp: "عنوان IP لآخر تسجيل دخول",
        lastSignIn: "آخر تسجيل دخول",
        signedInAs: "مسجّل الدخول باسم",
        sessionStatus: "حالة الجلسة",
        active: "نشطة",
        loginHistory: "سجل تسجيل الدخول",
        signInCount: "{{count}} عمليات تسجيل دخول",
        loadError: "تعذّر تحميل سجل تسجيل الدخول.",
        empty: "لم يتم تسجيل أي عمليات دخول بعد.",
        latest: "الأحدث",
        tipsTitle: "نصائح الأمان",
        tipStrongPassword: "استخدم كلمة مرور قوية وفريدة",
        tipEnable2fa: "فعّل المصادقة الثنائية عند توفرها",
        tipReviewHistory: "راجع سجل تسجيل الدخول بانتظام",
        tipSignOutShared: "سجّل الخروج من الأجهزة المشتركة",
        backToSettings: "العودة إلى الإعدادات"
      },
      profile: {
        newPasswordPlaceholder: "6 أحرف على الأقل",
        confirmPasswordPlaceholder: "أعد إدخال كلمة المرور الجديدة",
        passwordsMatch: "كلمتا المرور متطابقتان",
        account: "الحساب",
        provider: "المزوّد",
        providerEmailPassword: "البريد الإلكتروني / كلمة المرور",
        memberSince: "عضو منذ",
        lastSignIn: "آخر تسجيل دخول",
        deletePasswordPlaceholder: "أدخل كلمة المرور للتأكيد"
      },
      workspace: {
        available: "{{count}} مساحات عمل متاحة",
        empty: "لا توجد مساحات عمل",
        members: "الأعضاء",
        files: "الملفات",
        storage: "التخزين"
      },
      notifications: {
        total: "الإجمالي {{count}}",
        newBadge: "جديد"
      },
      admin: {
        allLicenses: "جميع التراخيص",
        platformBadge: "المنصة",
        demoDataTitle: "بيانات تجريبية",
        demoDataDesc: "ينشئ سجلات تجريبية في Firestore لجميع الوحدات ضمن حساب {{email}} حتى تتمكن الشركات الجديدة من استكشاف كل صفحة باستخدام بيانات Firebase حقيقية.",
        seedComplete: "اكتمل إنشاء البيانات التجريبية: {{count}} عمليات كتابة.",
        seeding: "جارٍ الإنشاء...",
        createDemoData: "إنشاء بيانات تجريبية",
        seedSignInRequired: "سجّل الدخول بحساب غير ضيف لإنشاء بيانات تجريبية.",
        seedConfirm: "سيؤدي هذا إلى كتابة سجلات تجريبية في قاعدة بيانات Firestore الخاصة بك للمستخدم المسجّل دخوله حاليًا. هل تريد المتابعة؟",
        auditAction: "الإجراء",
        auditResource: "المورد / التفاصيل",
        auditTime: "الوقت",
        drpackSourceValue: "licenses → AdminLicenses (نسخة للقراءة فقط)"
      }
    }
  }
};
